var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-md-12 col-lg-12"},[_c('div',{staticClass:"default-ImageEmpty"},[_c('img',{staticStyle:{"width":"300px"},attrs:{"src":`/assets/img/${_vm.image}`,"alt":""}}),_c('h3',{staticClass:"defaultTitle"},[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.subtitle))]),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }